import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import { routes } from './services/routes';
import './resources/iconfont.css';
import './scss/index.scss';

ReactDOM.render(routes(), document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
